import { apiClient } from './client'

export interface ScanJobDTO {
  id: number
  target_id: number
  preset: string
  status: 'queued' | 'running' | 'done' | 'failed'
  started_at: string | null
  finished_at: string | null
  error_message: string | null
  stats: { assets_found?: number; domains_queried?: number; duration_seconds?: number }
  arq_job_id: string | null
  created_at: string
  updated_at: string
}

export interface ScanCreate {
  target_id: number
  preset?: 'public_recon' | 'standard_sweep' | 'deep_audit'
}

export const scansApi = {
  list: (params?: { target_id?: number; status_filter?: string; limit?: number }) =>
    apiClient.get<ScanJobDTO[]>('/scans', { params }).then((r) => r.data),
  get: (id: number) => apiClient.get<ScanJobDTO>(`/scans/${id}`).then((r) => r.data),
  create: (body: ScanCreate) => apiClient.post<ScanJobDTO>('/scans', body).then((r) => r.data),
  remove: (id: number) => apiClient.delete(`/scans/${id}`).then(() => undefined),
}
